import { makeStyles } from "tss-react/mui";
import { MiBuildHouseAlt } from "@miplatform/assets";
import {
  MiListGroupedCard,
  MiPlaceholderArea,
  MiSkeleton,
  SKELETON_VARIANTS,
} from "@miplatform/components";
import { IActivity } from "@miplatform/types";
import {
  groupActivitiesByDate,
  groupActivitiesForTimeline,
} from "@miplatform/utils";
import { ActivityCard, ActivityTimeline } from "@mibuildweb/components";
import { Box } from "@mui/material";

export const PriceLevelHistory = ({
  priceLevelActivities,
  isLoading,
}: PriceLevelHistoryProps) => {
  const { classes, theme } = useStyles();

  return (
    <>
      {isLoading && (
        <MiSkeleton height={450} variant={SKELETON_VARIANTS.ROUNDED} />
      )}
      {!isLoading && priceLevelActivities.length === 0 && (
        <MiPlaceholderArea
          text="No Price Level History to Display"
          helperText="Assign a price level to this customer to see the history of price level changes."
          iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
          containerStyle={{
            backgroundColor: theme.palette.primary.light,
            height: "100%",
            minHeight: 450,
          }}
        />
      )}
      {!isLoading && priceLevelActivities.length > 0 && (
        <Box className={classes.timelineContainer}>
          {Object.entries(groupActivitiesByDate(priceLevelActivities)).map(
            ([date, activities]) => {
              const timelineData = {
                [date]: groupActivitiesForTimeline(activities),
              };

              return (
                <MiListGroupedCard
                  key={date}
                  title={date}
                  renderCard={
                    <ActivityTimeline
                      disableSpacing
                      data={timelineData}
                      showHeader={false}
                      showDate={false}
                      renderDetail={(activity: IActivity) => (
                        <ActivityCard key={activity.id} activity={activity} />
                      )}
                    />
                  }
                />
              );
            }
          )}
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  timelineContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));

type PriceLevelHistoryProps = {
  priceLevelActivities: IActivity[];
  isLoading: boolean;
};
